import axios from 'axios';
import { API_BASE_URL } from '../../config/ApiConfig';

const BASE = API_BASE_URL.TIPO_PAGAMENTO;

function getAuthConfig(params = {}) {
  const token = localStorage.getItem('token');
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  return { headers, params };
}

export function fetchTipoPagamentos(params = {}) {
  return axios.get(BASE, getAuthConfig(params)).then(r => r.data);
}

export function saveTipoPagamento(data, params = {}) {
  return axios.post(BASE, data, getAuthConfig(params)).then(r => r.data);
}

export function deleteTipoPagamento(codigo, params = {}) {
  return axios.delete(`${BASE}/${codigo}`, getAuthConfig(params));
}
